// extracted by mini-css-extract-plugin
var _1 = "DeleteTeam-module__animateUploadProgressBarWidth--GGL9c";
var _2 = "DeleteTeam-module__animatedBackground--Hy5Lq";
var _3 = "DeleteTeam-module__buttons--cSC22";
var _4 = "DeleteTeam-module__description--uA3xv";
var _5 = "DeleteTeam-module__wrapper--TxhgC";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "buttons", _4 as "description", _5 as "wrapper" }
